"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.includes = void 0;
/**
 * Performance optimized version of `Array.prototype.includes` method
 * (doesn't work for searching NaN value).
 *
 * Determines whether an array includes a certain value among its entries,
 * returning true or false as appropriate.

 * @see https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
 * @see includesNaN()
 *
 * **Limitations against native implementation**:
 * - **Doesn't work for searching NaN value. For that purpose, please use includesNaN()**.
 * - Doesn't accept the scope as last argument.
 *
 * @param {Array} array - Input array.
 * @param {*} valueToFind - Value to find in array.
 * @param {number} [fromIndex=0] - Index to start search from.
 *
 * @return {boolean}
 *
 * @example
 * import { includes } from '@24i/appstage-shared-perf-utils/dist/array';
 *
 * const array = ['item0', 'item1', 'item2'];
 *
 * //console.log(array.includes('item1')); // slower native solution
 * console.log(includes(array, 'item1'));  // faster
 * // expected output: true
 *
 * //console.log(array.includes('item1')); // slower native solution
 * console.log(includes(array, 'item1', 2));  // faster
 * // expected output: false
 */
const includes = (array, valueToFind, fromIndex = 0) => {
    for (let i = fromIndex, len = array.length; i < len; i++) {
        if (array[i] === valueToFind) {
            return true;
        }
    }
    return false;
};
exports.includes = includes;
